import React, {FC, useCallback, useState, useEffect} from "react";
import { useTask } from '../stateManagement/context';

import {
    AdequacyTypeID, ComponentTypeID,
    IAdequacy,
    IControlMeasure, IControlMeasureAssessment,
    IControlMeasureFailureMode,
    IControlType, IHarm,
    IProjectFailureMode
} from "../types/types";

import {TableCell, TableHead, TableRow, TextField} from "@material-ui/core";
import FailureModesControlMeasureSelect from "./failure_mode_control_measure";
import ControlTypeSelection from "./control_type";
import AdequacySelection from "./adequacy_selection";
import Comments from "./comments";


interface IControlMeasureAssessmentProps {
    control_measure: IControlMeasure
    failure_mode: IProjectFailureMode
    control_types: IControlType[]
    adequacies: IAdequacy[]
    control_measure_assessment: IControlMeasureAssessment
    updateControlMeasuresAssessment: (controlMeasureAssessment: IControlMeasureAssessment) => void;
}



const ControlMeasureAssessment: FC<IControlMeasureAssessmentProps> = ({
                                                                          control_measure,
                                                                          control_types,
                                                                          failure_mode,
                                                                          control_measure_assessment,
                                                                          adequacies,
                                                                          updateControlMeasuresAssessment
                                                                          // updateFailureModeControlMeasures,

                                                                      }) => {

    let tasks = useTask()

    const [justification, setJustification] = useState<string>(control_measure_assessment.justification as string);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    const updateAdequacies = useCallback((selected_id: number) => {
        control_measure_assessment.adequacy_id = selected_id;

        updateControlMeasuresAssessment(control_measure_assessment)

    }, [updateControlMeasuresAssessment]);


    return (
        <TableRow>
            <TableCell>{control_measure.description}</TableCell>
            <TableCell>{control_types.find(ct => ct.id === control_measure.control_type_id)?.name}</TableCell>
            <TableCell>
                <TextField
                    style ={{width: '100%'}}
                    inputProps={{ style: { fontSize: "11pt" } }}
                    id="standard-text"
                    disabled={!write_access}
                    value={justification}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    multiline={true}
                    onChange={(event) => {
                        let value = event.target.value
                        setJustification(value)
                        control_measure_assessment.justification = value
                    }

                    }
                    onBlur={(event) => {
                        let value = event.target.value
                        setJustification(value)
                        control_measure_assessment.justification = value
                        updateControlMeasuresAssessment(control_measure_assessment)
                    }

                    }

                />
            </TableCell>
            <TableCell><AdequacySelection adequacies={adequacies}
                                          type_id={AdequacyTypeID.ControlMeasure}
                                          initial_value={(control_measure_assessment.adequacy_id || 0).toString()}
                                          updateCallback={updateAdequacies}/></TableCell>

            <TableCell>{control_measure.uuid && <Comments parent_uuid={parseInt(""+ failure_mode.id + control_measure.uuid)} type_id={ComponentTypeID.ControlMeasureAssessment}/>}</TableCell>



        </TableRow>
    );
}

export default ControlMeasureAssessment;
